// removed by extract-text-webpack-plugin
module.exports = {"divGlobalBanner":"_2_Qcp7I","globalBanner":"_3KTlVF9","visible":"_1PxGDvU"};


//////////////////
// WEBPACK FOOTER
// ./template/components/GlobalBanner/index.css
// module id = ./template/components/GlobalBanner/index.css
// module chunks = client.sitechrome